module.exports = __webpack_public_path__ + "caa93b16eb15d10bd1437ba92f9d80dc.ttf";